'use strict';

(function initializeNpcWorkshopState(root) {
    const CURRENT_KEY = 'dnd-next-level:npc-workshop-current';
    const HISTORY_KEY = 'dnd-next-level:npc-workshop-history';
    const ACCESS_KEY = 'dnd-next-level:npc-workshop-access';
    const LOCKS_KEY = 'dnd-next-level:npc-workshop-locks:v1';
    const parseObject = raw => {
        try {
            const value = JSON.parse(raw);
            return value && typeof value === 'object' && !Array.isArray(value) ? value : null;
        } catch (_error) { return null; }
    };
    const isCanonical = value => Boolean(value?.format === 'dnd-next-level-npc-workshop-current'
        && value.version === 1 && value.workshop?.version === 1 && value.access && value.locks);
    const emptyLocks = () => ({version: 1, fields: []});
    const canonicalFromWorkshop = (workshop, access = {exportDmSecrets: true, editable: true}, locks = emptyLocks()) => ({
        format: 'dnd-next-level-npc-workshop-current', version: 1, workshop, access, locks,
    });
    const migrateCurrent = storage => {
        const value = parseObject(storage?.getItem(CURRENT_KEY));
        if (isCanonical(value)) return value;
        if (value?.version !== 1 || !value.form || !value.npc) return null;
        const legacyAccess = parseObject(storage.getItem(ACCESS_KEY));
        const playerSafe = legacyAccess?.dmSecrets === false && legacyAccess?.locked === true;
        const locks = parseObject(storage.getItem(LOCKS_KEY)) || emptyLocks();
        const migrated = canonicalFromWorkshop(value,
            playerSafe ? {exportDmSecrets: false, editable: false} : {exportDmSecrets: true, editable: true},
            playerSafe ? emptyLocks() : locks);
        storage.setItem(CURRENT_KEY, JSON.stringify(migrated));
        return migrated;
    };
    const readHistory = storage => {
        try {
            const value = JSON.parse(storage?.getItem(HISTORY_KEY) || '[]');
            return Array.isArray(value) ? value.slice(0, 10) : [];
        } catch (_error) { return []; }
    };
    const writeHistory = (storage, history) => {
        try { storage.setItem(HISTORY_KEY, JSON.stringify(history.slice(0, 10))); return true; }
        catch (_error) { return false; }
    };
    const remember = (history, workshop) => {
        if (!workshop?.npc) return history.slice(0, 10);
        const signature = JSON.stringify(workshop.npc);
        return [workshop, ...history.filter(item => JSON.stringify(item?.npc) !== signature)].slice(0, 10);
    };
    const displayName = npc => [npc?.name?.givenName, npc?.name?.nickname ? `“${npc.name.nickname}”` : '', npc?.name?.familyName]
        .filter(value => typeof value === 'string' && value.trim() && value.toLowerCase() !== 'defaultlastname').join(' ');
    root.dndNextLevel = root.dndNextLevel || {};
    root.dndNextLevel.npcWorkshopState = {
        currentKey: () => CURRENT_KEY, historyKey: () => HISTORY_KEY, parseObject, isCanonical,
        canonicalFromWorkshop, migrateCurrent, readHistory, writeHistory, remember, displayName,
    };
})(window);
